import { Carousel } from 'antd'
import React, { Component } from 'react';
import '../less/index.less';
import carousel1 from '../images/carousel1.jpg';
import carousel3 from '../images/carousel3.png';

class CarouselPage extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		let t = this

		return (
			<div className="carousel-page">
				<Carousel autoplay>
					<div>
						<img src={carousel3}/>
                    </div>
                    <div>
						<img src={carousel1}/>
					</div>
					{/* <div className="img"
                    style={{background: 'url(../images/carousel3.png) no-repeat center center'}}
					>
                    </div> */}
				</Carousel>
			</div>
		)
	}
}

export default CarouselPage